import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import './DropDownElement.scss'

const DropDownElement = ({ children, items, className, selectedIndex, callback }) => {
  const ref = useRef(null)

  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState(selectedIndex)

  const containerClasses = classNames(className, 'dropdown', {
    open: open
  })

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
  })

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false)
    }
  }

  const selectItem = (index, command) => {
    // items.forEach(function(i){
    //     i.selected = false;
    // })
    callback(index, command)
    setSelected(index)
  }

  if (items.lenght < 0) {
    return null
  }

  return (
    <div className={containerClasses} onClick={() => setOpen(!open)} ref={ref}>

      {children}

      <ul className='dropdown-menu dropdown-menu_discendant dropdown-menu_drop_down_element'>
        {items && items.map((item, i) =>
          (
            <li key={i} className={item.className}>
              <a className={i === selected ? 'is-selected ' + item.className : item.className} onClick={() => selectItem(i, item.command)}>{item.label}</a>
            </li>
          )
        )}
      </ul>
    </div>
  )
}

DropDownElement.defaultProps = {
  isOnlyText: true
}

DropDownElement.propTypes = {

  icon: PropTypes.string,
  callback: PropTypes.func,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    command: PropTypes.string,
    className: PropTypes.string
  }))
}

export default DropDownElement
